import React from 'react';
import { Navigate } from 'react-router-dom';
import AuthCard from 'features/auth/components/AuthCard/AuthCard';
import AuthFormHeader from 'features/auth/components/AuthFormHeader/AuthFormHeader';
import useUrlQuery from 'hooks/useUrlQuery';
import { getLoginPath } from 'utils/navigation';
import SetPasswordForm from '../components/SetPasswordForm/SetPasswordForm';

/**
 * Invite acceptance route — public at /set-password?token=xxx.
 * Validates token, shows password form, then auto-signs in on success.
 */
function SetPassword() {
  const query = useUrlQuery();
  const token = query.get('token');

  if (token) {
    return (
      <AuthCard>
        <AuthFormHeader />
        <SetPasswordForm token={token} />
      </AuthCard>
    );
  }

  return <Navigate to={getLoginPath()} />;
}

export default SetPassword;
